import { TMutation, TQuery } from 'app/Requests/types';
import httpDriver from 'app/utils/httpDriver';
import { apiRoutes } from 'videos/utils/apiRoutes';

export const addClientVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().addClientVideos, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const unnecessaryVideos = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().unnecessaryVideo, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes().deleteVideo, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

export const restoreVideo = async ({
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().restoreVideo, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const trashVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trashVideo, { ids: [id] });
  return { ...data, successMessage };
};
export const hideVideo = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().hideVideo, { ids: [id] });
  return { ...data, successMessage };
};

export const getVideoView = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().showVideo, {
    video_id: queryKey[1],
  });
  return data?.payload;
};

export const resyncVideos = async ({ id }: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().resyncVideo, {
    video_ids: [id],
  });
  return data;
};

export const addVideo = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().addVideo, body);
  return data;
};

export const compareVideos = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().compareVideo, {
    video_ids: queryKey[1],
  });
  return data?.payload?.records;
};

export const getVideoComments = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().videoDetailsComments, {
    video_id: queryKey[1],
  });
  return data?.payload?.records;
};

export const resyncTrendingVideos = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().resyncTrendingVideos);
  return data;
};

export const getRelatedTags = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().videoRelatedTags, {
    video_id: queryKey[1],
  });
  return data?.payload?.records;
};

export const getTrendingListVideo = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trendingList, {
    video_id: queryKey[1],
  });
  return data?.payload?.records;
};
export const getLastGrabbedOn = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().videosLastGrabbedOn);
  return data?.payload;
};

export const loadVideoGrabbingStatus = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().videoGrabbingStatus,
    queryKey[1]
  );
  return data.payload;
};
